import { StyleSheet } from 'aphrodite/no-important';

let styles = {
  base: {
    maxHeight: '100%',
    maxWidth: '100%',
    width: '100%'
  }
};

export default StyleSheet.create(styles);



// WEBPACK FOOTER //
// ./src/components/common/image/Image.styles.js